module.exports = __webpack_public_path__ + "static/media/logo.dec0dcf3.png";